import type { View, LayoutChangeEvent } from 'react-native'
import { usePositioningLayout } from '~/hooks/layout/use-positioning-layout'
import type { LayoutInfo } from '~/hooks/layout/types'

const POPOVER_CONSTANTS = {
  LAYOUT_RECALCULATION_DELAY: 100,
  LAYOUT_TOLERANCE: 1,
} as const

interface UsePopoverLayoutProps {
  isOpen: boolean
}

interface UsePopoverLayoutReturn {
  rootLayout: LayoutInfo | null
  isLayoutReady: boolean
  rootRef: React.RefObject<View>
  handleLayout: (event: LayoutChangeEvent) => void
}

export function usePopoverLayout({
  isOpen,
}: UsePopoverLayoutProps): UsePopoverLayoutReturn {
  const { layout, isLayoutReady, elementRef, handleLayoutChange } =
    usePositioningLayout({
      isActive: isOpen,
      config: {
        recalculationDelay: POPOVER_CONSTANTS.LAYOUT_RECALCULATION_DELAY,
        tolerance: POPOVER_CONSTANTS.LAYOUT_TOLERANCE,
      },
    })

  return {
    rootLayout: layout,
    isLayoutReady,
    rootRef: elementRef,
    handleLayout: handleLayoutChange,
  }
}
